import { gql } from "@apollo/client";

const GETUSERTOTALCHATCOUNT = gql`
  query getUserTotalChatCount($agentId: [ID], $timeFrame: String) {
    getUserTotalChatCount(agentId: $agentId, timeFrame: $timeFrame) {
      success
      error
      count
    }
  }
`;

export default GETUSERTOTALCHATCOUNT;
